import './Promo100.css';
import useWindowSize from '../../../../assets/hooks/useWindowSize';
import Promo100Pc from './Promo100Pc/Promo100Pc';
import Promo100Mobile from './Promo100Mobile/Promo100Mobile';


function Promo100({
    item,
    blackBannerRef,
}) {
    const { width } = useWindowSize()

    return (
        width <= 650 ?
            <Promo100Mobile
                blackBannerRef={blackBannerRef}
                item={item}
            />
            :
            <Promo100Pc
                blackBannerRef={blackBannerRef}
                item={item}
            />
    );
}

export default Promo100